import React from 'react';

function Error(){
    return (
        <h1>PAGE NOT FOUND!</h1>
    );
}

export default Error;